import posthog from 'posthog-js';
posthog.init(POSTHOG_API_KEY, {
  api_host: POSTHOG_HOST,
  enableExceptionAutocapture: true
});
export default posthog;